import React from "react"
import { Row, Col } from "react-bootstrap"
import Knob from "./lib/knob"
import Input from "./lib/input"
import Switch from "./lib/switch"
import Text from "./lib/text"
import Label from "./lib/label"
import { Stage, Layer, Circle, Shape } from "react-konva"
import WaveImage from "./WaveImage"
import CurvePainter from "./CurvePainter"

class Waveterrain extends React.Component {
  constructor(props) {
    super(props)
    this.state = { x: 0, y: 0, zoom: 2, offx: 0, offy: 0, rot: 0, p1: 0, rx: 0.5, ry: 0.5, curve: 7 }
    this.h = 256
    this.w = 256
    this.curve = {
      id: "curve", type: "select", label: "curve", defval: 0, vertical: true, midictrl: 106, items: [
        { name: "ellipse", value: 0 },
        { name: "lemg", value: 1 },
        { name: "limacon", value: 2 },
        { name: "cornoid", value: 3 },
        { name: "trisec", value: 4 },
        { name: "scarabeus", value: 5 },
        { name: "folium", value: 6 },
        { name: "talbot", value: 7 },
      ],
    }
    this.rx = { id: "rx", type: "knob", label: "rx", min: 0, max: 1, step: 0.01, defval: 0.5, height: 35, width: 35, midictrl: 104 }
    this.ry = { id: "ry", type: "knob", label: "ry", min: 0, max: 1, step: 0.01, defval: 0.5, height: 35, width: 35, midictrl: 105 }
    this.rot = {
      id: "rot",
      type: "knob",
      label: "rot",
      min: 0,
      max: 6.28,
      step: 0.01,
      defval: 0,
      height: 35,
      width: 35,
      digits: 3,
      midictrl: 102
    }
    this.param = {
      id: "p1",
      type: "knob",
      label: "param",
      min: -4,
      max: 5,
      step: 0.01,
      defval: 0,
      height: 35,
      width: 35,
      midictrl: 103
    }
    this.wave1 = { id: "gst1", type: "input", label: "wave1", width: 370, defval: "10 1" }
    this.wave2 = { id: "gst2", type: "input", label: "wave2", width: 370, defval: "10 1" }
    let tbldoc = nr => `<a target="_blank" href="https://csound.com/docs/manual/GEN${nr < 10 ? "0" + nr : nr}.html">${nr}</a>`
    let t = `Supported Tables are GEN ${tbldoc(3)},${tbldoc(5)},${tbldoc(6)},${tbldoc(7)},${tbldoc(8)},${tbldoc(9)},${tbldoc(10)},${tbldoc(11)},${tbldoc(12)},${tbldoc(13)},${tbldoc(14)},<br/> ${tbldoc(15)},${tbldoc(16)},${tbldoc(17)},${tbldoc(19)},${tbldoc(20)},${tbldoc(21)},${tbldoc(25)},${tbldoc(27)}. The segment lengths in GEN05,<br/> GEN06, GEN07, GEN08, GEN17, GEN25, GEN27 must be <br/>passed as fractions of 1 (i.e. the lengths or duration <br/>should sum up to 1 instead of the table length).  `
    this.text = { id: "text", type: "text", text: t }
    this.trig = false
    this.props.def.changeValue = this.setValue.bind(this);
    this.props.def.setCtrlValue = this.setCtrlValue.bind(this);
    let self = this
    this.components = {
      gst1: self.wave1,
      gst2: self.wave2,
      curve: self.curve,
      rx: self.rx,
      ry: self.ry,
      rot: self.rot,
      p1: self.param,
    }
    Object.values(this.components).forEach( component => component.tooltip=this.computeTooltip(component));
  }

  computeTooltip(elem) {
    return (elem.tooltip?elem.tooltip:'')
      + (elem.midictrl?' ctrl:'+elem.midictrl:'')
      + (this.props.def.osc? ' osc:/'+this.props.def.osc+'/'+this.props.def.id+'/'+elem.id:'')
  }

  async onStart() {
    console.log("start")
    this.cs = this.props.cs
    this.trig = true
  }

  componentDidMount() {
    this.canvas = document.createElement("canvas")
    this.canvas.width = this.w
    this.canvas.height = this.h
    this.genImg = new WaveImage(this.canvas)
    this.curvePainter = new CurvePainter()
  }

  async updateImage(context) {
    if (this.cs) {
      if (this.tbl1 === undefined) this.tbl1 = await this.cs.getChannel("tablenr1")
      if (this.tbl2 === undefined) this.tbl2 = await this.cs.getChannel("tablenr2")
      this.tblen = await this.cs.getTableLength(this.tbl1)
      if (this.tblen > 0 && this.trig) {
        try {
          this.fn1 = await this.cs.getTable(this.tbl1)
          this.fn2 = await this.cs.getTable(this.tbl2)
          if (this.fn1) {
            this.genImg.updateImage(this.fn1, this.fn2)
            context.drawImage(this.canvas, 0, 0)
            this.trig = false
          }
        } catch (e) {
          console.log(e)
          this.fn1 = await this.cs.getTable(this.tbl1)
          this.fn2 = await this.cs.getTable(this.tbl2)
          if (this.fn1) {
            this.genImg.updateImage(this.fn1, this.fn2)
            context.drawImage(this.canvas, 0, 0)
            this.trig = false
          }
        }
      }
    }
  }

  round(val) {
    return Math.round(val * 1000) / 1000
  }

  toPixX(valX) {
    let ret = (valX / (this.state.zoom / 2)) * (this.w / 2) + this.w / 2
    return ret
  }

  toPixY(valY) {
    let ret = (valY / (this.state.zoom / 2)) * (this.h / 2) + this.h / 2
    return ret
  }

  fromPixX(x) {
    return (x - this.w / 2) / (this.w / 2) * (this.state.zoom / 2)
  }

  fromPixY(y) {
    return (y - this.h / 2) / (this.h / 2) * (this.state.zoom / 2)
  }

  setY(y) {
    this.setState({ y: y })
    this.circle.y(this.toPixY(y))
    this.props.onChange(this.props.def.id, { y: this.round(-y) })
  }

  setX(x) {
    this.setState({ x: x })
    this.circle.x(this.toPixX(x))
    this.props.onChange(this.props.def.id, { x: this.round(x) })
  }

  setValue(val) {
    Object.keys(val).forEach(key => {
      if (key === "x") this.setX(val[key])
      else if (key === "y") this.setY(-val[key])
      else this.components[key].changeValue(val[key])
    })
  }

  setCtrlValue(nr, val) {
    const v = val/127;
    switch(nr) {
      case 100:
        this.setValue({ x: -1 + 2 * v });break;
      case 101:
        this.setValue({ y: -1 + 2 * v });break;
      case 102:
        this.setValue({ rot: 6.28 * v });break;
      case 103:
        this.setValue({ p1: -4 + 9 * v });break;
      case 104:
        this.setValue({ rx:  v });break;
      case 105:
        this.setValue({ ry: v });break;
      case 106:
        this.setValue({ curve: Math.floor(val / 16) });break;
    }
  }

  drag() {
    let x = this.fromPixX(this.circle.attrs.x)
    let y = this.fromPixY(this.circle.attrs.y)
    this.setState({ x: x, y: y })
    this.props.onChange(this.props.def.id, { "x": this.round(x), y: this.round(-y) })
  }

  onChange(id, val) {
    if (id === this.wave1.id || id === this.wave2.id) this.trig = true
    this.props.onChange(this.props.def.id, { [id]:val})
    let obj = {}
    obj[id] = val
    this.setState(obj)
  }

  render() {
    return (
      <Col md="auto">
        <Row style={{ flexWrap: "wrap" }}>
          <Col md="auto">
            <Row style={{ flexWrap: "nowrap" }}>
              <Col>
                <Row>
                  <Label tooltip={'ctrl:100 osc:/'+this.props.def.osc+'/'+this.props.def.id+'/'+'x'} label="x:"/>
                  <Col>{this.round(this.state.x)}</Col>
                  <Label tooltip={'ctrl 101 osc:/'+this.props.def.osc+'/'+this.props.def.id+'/'+'y'} label="y:"/>
                  <Col>{this.round(-this.state.y)}</Col>
                </Row>
                <Row noGutters>
                  <Col style={{ backgroundColor: "#FDF6E3" }} md="auto">
                    <Stage x={0} y={0} width={this.w} height={this.h} ref={ref => (this.stage = ref)}>
                      <Layer>
                        <Shape x={0} y={0} sceneFunc={(context, shape) => {
                          if (this.canvas) {
                            this.updateImage(context)
                            context.drawImage(this.canvas, 0, 0)
                          }
                        }}>
                        </Shape>
                      </Layer>
                      <Layer>
                        <Shape stroke="white" strokeWith={3} sceneFunc={(context, shape) => {
                          if (this.canvas) {
                            this.curvePainter.drawCurve(context, shape, this.state.x, this.state.y, this.w, this.h, this.state.zoom, this.state.curve, this.state.p1, this.state.rot, this.state.rx, this.state.ry)
                          }
                        }}>
                        </Shape>
                      </Layer>
                      <Layer>
                        <Circle onDragMove={this.drag.bind(this)} ref={ref => (this.circle = ref)}
                                x={this.toPixX(this.state.x)} y={this.toPixY(this.state.y)} radius={5}
                                fill="rgb(0,68,238)"
                                draggable>
                        </Circle>
                      </Layer>
                    </Stage>
                  </Col>
                </Row>
              </Col>
              <Switch def={this.curve} onChange={this.onChange.bind(this)} vertical />
              <Col md="auto">
                <Row><Col><Knob def={this.rx} key={this.rx.id} onChange={this.onChange.bind(this)} /></Col></Row>
                <Row><Col><Knob def={this.ry} key={this.ry.id} onChange={this.onChange.bind(this)} /></Col></Row>
                <Row><Col><Knob def={this.rot} key={this.rot.id} onChange={this.onChange.bind(this)} /></Col></Row>
                <Row><Col><Knob def={this.param} key={this.param.id} onChange={this.onChange.bind(this)} /></Col></Row>
              </Col>
            </Row>
          </Col>
          <Col xs="auto">
            <Row>
              <Col xs="auto"><Input def={this.wave1} key={this.wave1.id} onChange={this.onChange.bind(this)} /></Col>
            </Row>
            <Row>
              <Col xs="auto"><Input def={this.wave2} key={this.wave2.id} onChange={this.onChange.bind(this)} /></Col>
            </Row>
            <Row>
              <Text def={this.text} />
            </Row>
          </Col>
        </Row>
      </Col>
    )
  }

}

export default Waveterrain
